import React, { useState } from 'react';
import styles from './styles.module.scss';
import { gql } from '../../utils/graphql';

interface ResetPasswordProps {
	token: string;
	onBackToLogin: () => void;
}

const ResetPassword: React.FC<ResetPasswordProps> = ({ token, onBackToLogin }) => {
	const [newPassword, setNewPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [error, setError] = useState('');
	const [success, setSuccess] = useState('');
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setError('');
		setSuccess('');

		if (newPassword.length < 6) {
			setError('Parola trebuie să aibă cel puțin 6 caractere');
			return;
		}

		if (newPassword !== confirmPassword) {
			setError('Parolele nu coincid');
			return;
		}

		setLoading(true);

		try {
			const query = `
				mutation ResetAmbassadorPassword($token: String!, $newPassword: String!) {
					resetAmbassadorPassword(token: $token, newPassword: $newPassword)
				}
			`;

			const response = await gql(query, { token, newPassword });

			if (response.data?.errors) {
				throw new Error(response.data.errors[0].message);
			}

			setSuccess('Parola a fost resetată cu succes! Te poți autentifica acum.');
		} catch (err: any) {
			setError(err.message || 'Resetarea parolei a eșuat');
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className={styles.authContainer}>
			<h1 className={styles.title}>Resetare Parolă</h1>
			<p className={styles.userHandle} style={{ marginBottom: '2rem' }}>
				Introdu noua ta parolă
			</p>

			<div className={styles.card}>
				{success ? (
					<>
						<div className={`${styles.msgBox} ${styles.msgSuccess}`}>
							{success}
						</div>
						<button
							type="button"
							onClick={onBackToLogin}
							className={styles.button}
							style={{ width: '100%' }}
						>
							Înapoi la Autentificare
						</button>
					</>
				) : (
					<form onSubmit={handleSubmit}>
						<input
							type="password"
							placeholder="Parolă nouă *"
							className={styles.inputBase}
							value={newPassword}
							onChange={(e) => setNewPassword(e.target.value)}
							required
							disabled={loading}
							minLength={6}
						/>
						<input
							type="password"
							placeholder="Confirmă parola *"
							className={styles.inputBase}
							value={confirmPassword}
							onChange={(e) => setConfirmPassword(e.target.value)}
							required
							disabled={loading}
							minLength={6}
						/>

						{error && (
							<div className={`${styles.msgBox} ${styles.msgError}`}>
								{error}
							</div>
						)}

						<button type="submit" className={styles.button} disabled={loading} style={{ width: '100%' }}>
							{loading ? 'Se procesează...' : 'Resetează Parola'}
						</button>

						<div style={{ marginTop: '1.5rem', borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '1.5rem' }}>
							<button
								type="button"
								onClick={onBackToLogin}
								style={{
									background: 'transparent',
									border: 'none',
									color: '#EFA43B',
									cursor: 'pointer',
									fontSize: '1rem',
									fontWeight: 'bold',
									textDecoration: 'underline'
								}}
							>
								Înapoi la Autentificare
							</button>
						</div>
					</form>
				)}
			</div>
		</div>
	);
};

export default ResetPassword;
